import { memo, useEffect, useMemo, useState } from "react";

import { useAppDispatch } from "../redux/store";
import { addSticker } from "../redux/lounges/slice";
import { GET_BASE_URL_IMAGE } from "../constants/apiEndpoints";
import moment from "moment";
type StickerTabPropsType = {
  tabData: any;
  onClickSticker: any;
};

function Tab(props: any) {
  const dispatch = useAppDispatch();
  const getStickerName = (sticker: any): string =>
    String(sticker?.product_name || "").trim();
  const onAddSticker = (data: any, item: any) => {
    props.onClick(
      GET_BASE_URL_IMAGE + "/disneyland/images/products_thumbnail/" + data,
      item
    );

    dispatch<any>(addSticker(data));
  };
  const emojiData = props?.filter
    ? props?.allData
    : [...(props?.tab?.getemojidata || [])];
  const sortedCollection = emojiData.length
    ? [...emojiData].sort((a: any, b: any) => {
        if (props?.sortedBy === "name") {
          const aName = getStickerName(a);
          const bName = getStickerName(b);
          if (!aName && !bName) return 0;
          if (!aName) return 1;
          if (!bName) return -1;
          return aName.localeCompare(bName);
        }
        return moment.utc(b?.createdon).diff(moment.utc(a?.createdon));
      })
    : [];
  const filteredCollection = sortedCollection.filter((sticker: any) =>
    getStickerName(sticker)
      .toLowerCase()
      .includes(String(props?.filter || "").toLowerCase())
  );
  return (
    <div className="tab-content sticker-tabs-content">
      <div className="tab-pane fade active show sticker-tabs-pane">
        {filteredCollection.length === 0 ? (
          <p className="sticker-tabs-empty">No stickers found.</p>
        ) : (
          filteredCollection.map((item: any, index: any) => (
            <img
              key={index}
              onClick={() => onAddSticker(item.product_image, item)}
              src={
                GET_BASE_URL_IMAGE +
                "/disneyland/images/products_thumbnail/" +
                item.product_image
              }
              className="img-fluid sticker-tabs-image"
              alt={getStickerName(item) || "sticker"}
            />
          ))
        )}
      </div>
    </div>
  );
}

function Navigation(props: any) {
  return (
    <div className="sticker-tabs-navigation">
      <div className="sticker-tabs-toolbar">
        <div className="sticker-tabs-search">
          <div className="input-group bg-white border rounded-pill p-1">
            <input
              placeholder="Search ..."
              aria-describedby="button-addon4"
              className="form-control border-0"
              value={props?.filter}
              onChange={(e) => props?.setFilter(e.target.value)}
            />
          </div>
        </div>
        <div className="sticker-tabs-sort">
          <h6 className="sticker-tabs-sort-label">Sorted By</h6>
          <div>
            <select
              className="form-select"
              aria-label="Sticker sort order"
              value={props?.sortedBy}
              onChange={(e) => {
                localStorage.setItem("sortedBy", e.target.value);
                props?.setSortedBy(e.target.value);
              }}
            >
              <option value={"name"}>Name</option>
              <option value={"date"}>Date</option>
            </select>
          </div>
        </div>
      </div>
      <div className="sticker-tabs-categories">
        <ul className="nav nav-pills sticker-tabs-nav">
          {props.tabs.map((item: any) => (
            <li key={item?.id} className={`nav-item`}>
              <span
                className={`nav-link ${
                  props.activeTabId === item?.id ? "active" : ""
                }`}
                onClick={() => props.onNavClick(item?.id)}
              >
                {item.emoji_category_name}
              </span>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
}

export const StickerTabs: React.FC<StickerTabPropsType> = ({
  tabData,
  onClickSticker,
}) => {
  const orderedTabs = useMemo(() => {
    const normalizedTabs = Array.isArray(tabData) ? tabData : [];
    const stickerFairyTabs = normalizedTabs.filter((tab: any) =>
      String(tab?.emoji_category_name || "")
        .toLowerCase()
        .includes("sticker fairy")
    );
    const otherTabs = normalizedTabs.filter(
      (tab: any) => !stickerFairyTabs.includes(tab)
    );
    return [...stickerFairyTabs, ...otherTabs];
  }, [tabData]);
  const [activeTabId, setActiveTab] = useState(orderedTabs[0]?.id);
  const [filter, setFilter] = useState("");
  const [sortedBy, setSortedBy] = useState(
    localStorage.getItem("sortedBy") || "name"
  );
  useEffect(() => {
    if (
      orderedTabs.length > 0 &&
      !orderedTabs.some((tab: any) => tab?.id === activeTabId)
    ) {
      setActiveTab(orderedTabs[0]?.id);
    }
  }, [activeTabId, orderedTabs]);
  const activeTab = useMemo(
    () => orderedTabs.find((tab: any) => tab?.id === activeTabId),
    [activeTabId, orderedTabs]
  );
  const allData = useMemo(() => {
    return orderedTabs.flatMap((item: any) => item?.getemojidata || []);
  }, [orderedTabs]);
  return (
    <div className="com-box-main sticker-tabs-panel">
      <div className="post-sec">
        <div className="tabs">
          <Navigation
            tabs={orderedTabs}
            onNavClick={setActiveTab}
            activeTabId={activeTabId}
            setSortedBy={setSortedBy}
            sortedBy={sortedBy}
            setFilter={setFilter}
            filter={filter}
          />
          <Tab
            tab={activeTab}
            onClick={onClickSticker}
            sortedBy={sortedBy}
            filter={filter}
            allData={allData}
          />
        </div>
      </div>
    </div>
  );
};

export default memo(StickerTabs);
